<template>
  <div class = "btn-social-long-twitter">
    　　 <a href="https://twitter.com/intent/tweet?url=https://siruq.site&&hashtags=しるQ&related=Q18807506" target="_blank"><v-fa :icon="['fab', 'twitter']" /> 回答する</a>
  </div>
</template>

<script>
  import firebase from 'firebase'
  export default {
      name: "AnswerBtn",
      data () {
        return {
          hashtag: "しるQ",
          q : '',
        }
      },
    beforeCreate() {
          var database = firebase.database();
          var dataRef = database.ref('/questions');
          var hashtags = "";
          var preurl = "";
          dataRef.once("value")
            .then(function(snapshot) {
              var day =　new Date().getDate();
              hashtags = snapshot.child(String(day)).val().replace(/？|。|、|」|「|/g, '');
              preurl = "https://twitter.com/intent/tweet?url=https://siruq.site&&hashtags=しるQ," + hashtags + "&related=Q18807506"
              var elem = document.getElementsByClassName("btn-social-long-twitter")
              for(var i = 0;i < elem.length;i++){
                document.getElementsByClassName("btn-social-long-twitter")[i].children[0].href = preurl
              }
            })
          return preurl = "https://twitter.com/intent/tweet?url=siruq.site&&hashtags=しるQ," + hashtags + "&related=Q18807506"
        }
    }
</script>

<style>
  .btn-social-long-twitter {
    color: #FFF;/*文字・アイコン色*/
    border-radius: 7px;/*角丸に*/
    display: inline-block;
    height: 50px;/*高さ*/
    width: 190px;/*幅*/
    text-align: center;/*中身を中央寄せ*/
    font-size: 25px;/*文字のサイズ*/
    line-height: 50px;/*高さと合わせる*/
    background: #8c98ff;
    overflow: hidden;/*はみ出た部分を隠す*/
    text-decoration:none;/*下線は消す*/
    font-weight: bold;
  }
  .btn-social-long-twitter> a{
    text-decoration:none;/*下線は消す*/
    color:#f8f8ff;
  }

  .btn-social-long-twitter .fa-twitter {
    text-shadow: 2px 2px 0px #4287d6;
    font-size: 30px;
  }

  .btn-social-long-twitter span {
    display:inline-block;
    transition: .5s;
  }


</style>



// WEBPACK FOOTER //
// src/components/AnswerBtn.vue